import { HOME_INSIGHT_MODE_ORDER } from '../../../constants/guestVerseInsightModes';

const MODE_ORDER = HOME_INSIGHT_MODE_ORDER;

const STORAGE_PREFIX = 'bf_home_insight_step:';

export function readHomeInsightStep(verseDayKey) {
  if (!verseDayKey) return 0;
  try {
    const raw = localStorage.getItem(STORAGE_PREFIX + verseDayKey);
    const n = parseInt(raw, 10);
    if (Number.isNaN(n) || n < 0) return 0;
    return Math.min(n, MODE_ORDER.length);
  } catch {
    return 0;
  }
}

/** После просмотра режима — показываем следующую ссылку на главной. */
export function advanceHomeInsightStep(verseDayKey, completedMode) {
  if (!verseDayKey) return 0;
  const idx = MODE_ORDER.indexOf(completedMode);
  if (idx < 0) return readHomeInsightStep(verseDayKey);
  const next = Math.max(readHomeInsightStep(verseDayKey), idx + 1);
  try {
    localStorage.setItem(STORAGE_PREFIX + verseDayKey, String(next));
  } catch {
    /* no-op */
  }
  return next;
}

export function getHomeInsightLinkForStep(step) {
  if (step < 0 || step >= MODE_ORDER.length) return null;
  return MODE_ORDER[step];
}

export { MODE_ORDER };
export { HOME_INSIGHT_MODE_ORDER } from '../../../constants/guestVerseInsightModes';
